module.exports = __webpack_public_path__ + "img/logout.46da5d0f.png";